export const adhd_asrs = {
    "slug": "adhd_asrs",
    "maxScore": 6,
    "threshold": 4,
    "scoreUnitKey": "Criteria Met",
    "totalQuestions": 18,
    "estimatedTimeMinutes": 3,
    "translations": {
        "name": {
            "en": "ADHD (ASRS)",
            "bg": "ADHD (ASRS)"
        },
        "description": {
            "en": "What it does: This short questionnaire helps screen for symptoms of Attention-Deficit/Hyperactivity Disorder (ADHD) in adults. It focuses on concentration, impulsivity, and restlessness to identify patterns that may suggest ADHD.\nWhy take it: If you often feel distracted, forgetful, or struggle to stay organized, this test can offer insights and suggest whether further evaluation may be helpful.",
            "bg": "Какво представлява: Този кратък въпросник помага за скрининг на симптоми на Разстройство на вниманието с хиперактивност (СДВХ - Синдром на дефицит на вниманието с хиперактивност) при възрастни. Той се фокусира върху концентрацията, импулсивността и неспокойствието, за да идентифицира модели, които могат да предполагат наличие на ADHD.\nЗащо да го направите: Ако често се разсейвате, забравяте или ви е трудно да се организирате, този тест може да предостави полезна информация и да подскаже дали е необходимо допълнително изследване."
        },
        "results": {
            "suggestive": {
                "en": "Your responses are highly consistent with symptoms of adult ADHD.",
                "bg": "Вашите отговори са силно съвместими със симптомите на ADHD при възрастни."
            },
            "part_a_high": {
                "en": "You scored {{score}} in Part A, which exceeds the clinical threshold of 4.",
                "bg": "Вашият резултат в Част A е {{score}}, което надвишава клиничния праг от 4 точки."
            },
            "not_suggestive": {
                "en": "Your responses are not strongly indicative of ADHD.",
                "bg": "Вашите отговори не показват ясни признаци за наличие на ADHD."
            },
            "part_a_low": {
                "en": "Your Part A score was {{score}}, which is below the diagnostic threshold.",
                "bg": "Резултатът ви в Част A е {{score}}, което е под диагностичния праг."
            },
            "part_b_info": {
                "en": "Your Part B score was {{score}}, reflecting broader functional impact.",
                "bg": "Вашият резултат в Част B е {{score}}, което показва по-широко въздействие върху функционирането."
            },
            "subscales": {
                "en": "Subscale scores — Inattentive: {{inattentive}}, Hyperactive (Motor): {{motor}}, Hyperactive (Verbal): {{verbal}}.",
                "bg": "Подскали — Невнимание: {{inattentive}}, Хиперактивност (Моторна): {{motor}}, Хиперактивност (Вербална): {{verbal}}."
            },
            "clinical_note": {
                "en": "This tool is a screening measure and should be interpreted alongside a clinical interview with a mental health professional.",
                "bg": "Този инструмент е скринингов и трябва да се използва в съчетание с клинично интервю с квалифициран специалист по психично здраве."
            }
        }
    },
    "resultsSection": {
        "didYouKnow": {
            "en": "Executive dysfunction—not a lack of willpower—is the primary driver of adult ADHD symptoms. Over 60% of children with ADHD continue to experience symptoms into adulthood, often appearing as chronic procrastination and brain fog rather than physical hyperactivity.",
            "bg": "Екзекутивната дисфункция — а не липсата на воля — е основният двигател на симптомите на ADHD при възрастните. Над 60% от децата с ADHD продължават да изпитват симптоми и в зряла възраст, които често се проявяват като хронична прокрастинация и „мъгла в главата“, а не като физическа хиперактивност."
        },
        "faqs": [
            {
                "question": {
                    "en": "What is the difference between Part A and Part B?",
                    "bg": "Каква е разликата между Част А и Част Б?"
                },
                "answer": {
                    "en": "Part A contains the 6 most predictive questions for adult ADHD screening. Part B measures 12 additional items across Inattention and Impulsivity to gauge total symptom severity.",
                    "bg": "Част А съдържа 6-те най-прогностични въпроса за скрининг на ADHD при възрастни. Част Б измерва 12 допълнителни елемента за оценка на общата тежест на симптомите."
                }
            },
            {
                "question": {
                    "en": "Does a high score mean I have ADHD?",
                    "bg": "Означава ли висок резултат, че имам ADHD?"
                },
                "answer": {
                    "en": "No. This screener measures symptom intensity for self-awareness. A formal diagnosis requires a comprehensive clinical evaluation by a healthcare provider.",
                    "bg": "Не. Този скрининг инструмент измерва интензивността на симптомите за самоопознаване. Официалната диагноза изисква задълбочена клинична оценка от специалист."
                }
            },
            {
                "question": {
                    "en": "Why do my focus levels change daily?",
                    "bg": "Защо нивата ми на концентрация се променят ежедневно?"
                },
                "answer": {
                    "en": "ADHD symptoms fluctuate based on sleep, stress, and task novelty. High interest can trigger hyperfocus, while routine tasks exhaust working memory.",
                    "bg": "Симптомите на ADHD флуктуират в зависимост от съня, стреса и новостта на задачата. Високият интерес може да предизвика хиперфокус, докато рутинните задачи изтощават работната памет."
                }
            }
        ]
    },
    "answerOptions": [
        { "value": 1, "translations": { "en": "Never", "bg": "Никога" } },
        { "value": 2, "translations": { "en": "Rarely", "bg": "Рядко" } },
        { "value": 3, "translations": { "en": "Sometimes", "bg": "Понякога" } },
        { "value": 4, "translations": { "en": "Often", "bg": "Често" } },
        { "value": 5, "translations": { "en": "Very often", "bg": "Много често" } }
    ],
    "questions": [
        {
            "order": 1,
            "translations": {
                "en": "How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?",
                "bg": "Колко често имате проблеми с приключването на финалните детайли на проект, след като по-трудната част е готова?"
            }
        },
        {
            "order": 2,
            "translations": {
                "en": "How often do you have difficulty getting things in order when you have to do a task that requires organisation?",
                "bg": "Колко често ви е трудно да се организирате кога и как да свършите някаква задача?"
            }
        },
        {
            "order": 3,
            "translations": {
                "en": "How often do you have problems remembering appointments or obligations?",
                "bg": "Колко често имате проблеми със запомнянето на срещи или задължения?"
            }
        },
        {
            "order": 4,
            "translations": {
                "en": "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?",
                "bg": "Колко често избягвате/отлагате започването на задача, която изисква концентрация, ангажираност и креативност?"
            }
        },
        {
            "order": 5,
            "translations": {
                "en": "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?",
                "bg": "Колко често помръдвате, правите малки движения с ръце или крака, когато трябва да седите за дълго време?"
            }
        },
        {
            "order": 6,
            "translations": {
                "en": "How often do you feel overly active and compelled to do things, like you were driven by a motor?",
                "bg": "Колко често се чувствате прекалено активни и принудени да вършите неща, сякаш задвижени от двигател?"
            }
        },
        {
            "order": 7,
            "translations": {
                "en": "How often do you make careless mistakes when you have to work on a boring or difficult project?",
                "bg": "Колко често допускате грешки от невнимание, когато трябва да работите по скучен или труден проект?"
            }
        },
        {
            "order": 8,
            "translations": {
                "en": "How often do you have difficulty keeping your attention when you are doing boring or repetitive work?",
                "bg": "Колко често ви е трудно да задържите вниманието си, когато вършите скучна или рутинна работа?"
            }
        },
        {
            "order": 9,
            "translations": {
                "en": "How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?",
                "bg": "Колко често ви е трудно да се концентрирате върху това, което хората ви казват, дори когато ви говорят директно?"
            }
        },
        {
            "order": 10,
            "translations": {
                "en": "How often do you misplace or have difficulty finding things at home or at work?",
                "bg": "Колко често губите или изпитвате трудности да намерите неща у дома или на работа?"
            }
        },
        {
            "order": 11,
            "translations": {
                "en": "How often are you distracted by activity or noise around you?",
                "bg": "Колко често се разсейвате от дейност или шум около вас?"
            }
        },
        {
            "order": 12,
            "translations": {
                "en": "How often do you leave your seat in meetings or other situations in which you are expected to remain seated?",
                "bg": "Колко често ставате от мястото си в социална/работна ситуация, в която се очаква да останете седнали?"
            }
        },
        {
            "order": 13,
            "translations": {
                "en": "How often do you feel restless or fidgety?",
                "bg": "Колко често се чувствате неспокоен или нервен?"
            }
        },
        {
            "order": 14,
            "translations": {
                "en": "How often do you have difficulty unwinding and relaxing when you have time to yourself?",
                "bg": "Колко често ви е трудно да се отпуснете, когато имате време за себе си?"
            }
        },
        {
            "order": 15,
            "translations": {
                "en": "How often do you find yourself talking too much when you are in social situations?",
                "bg": "Колко често се улавяте, че говорите твърде много, когато сте в социални ситуации?"
            }
        },
        {
            "order": 16,
            "translations": {
                "en": "When you’re in a conversation, how often do you find yourself finishing the sentences of the people you are talking to, before they can finish them themselves?",
                "bg": "Колко често се улавяте, че довършвате изреченията на хората, с които говорите, преди те самите да имат тази възможност?"
            }
        },
        {
            "order": 17,
            "translations": {
                "en": "How often do you have difficulty waiting your turn in situations when turn taking is required?",
                "bg": "Колко често срещате затруднения да изчакате реда си в ситуации, когато се изисква да чакате на опашка?"
            }
        },
        {
            "order": 18,
            "translations": {
                "en": "How often do you interrupt others when they are busy?",
                "bg": "Колко често прекъсвате другите, когато те са заети с конкретна задача/ситуация?"
            }
        }
    ]
}